import { Injectable, Injector } from '@angular/core';
import { Headers, Http, RequestOptions, Response } from '@angular/http';
import { Observable } from '../../../node_modules/rxjs/Observable';
import { Role } from '../models/role.model';
import { AuthService } from '../services/auth.service';
import { ConfigurationService } from '../services/configuration.service';
import { AccountEndpoint } from './account-endpoint.service';

@Injectable()
export class RoleServices {
    private readonly _accountUrl: string = "/api/Account";
    private _authService: AuthService;

    private get authService() {
        if (!this._authService)
            this._authService = this.injector.get(AuthService);

        return this._authService;
    }
    constructor(private http: Http, private injector: Injector, private accountEndPointService: AccountEndpoint) { }

    saverole(plate: Role) {

        return this.http.post(this._accountUrl + '/SaveRoles', JSON.stringify(plate), this.getAuthHeader(true))
            .map((response: Response) => {               
                return response;
            });
    }

    getAllRoles() {
        return this.http.get(this._accountUrl + '/GetRoles').map((response: Response) => {
            return response;
        });
    }

    deleteBacteria(plate: Role) {
        return this.http.post(this._accountUrl + '/Delete', JSON.stringify(plate), this.getAuthHeader(true)).map((response: Response) => {
            return response;
        });
    }

    getDefaultApplicationRoleNames() {
        return this.http.get(this._accountUrl + '/GetDefaultApplicationRoleNames', this.getAuthHeader(true)).map((response: Response) => {
            return response;
        });
    }

    getRolesAndDefaultApplicationRoleNames() {
        return Observable.forkJoin([this.accountEndPointService.getRolesEndPoint<Role[]>(),
        this.accountEndPointService.getDefaultApplicationRoleNamesEndPoint<any>()]);
    }

    protected getAuthHeader(includeJsonContentType?: boolean): RequestOptions {
        let headers = new Headers({ 'Authorization': 'Bearer ' + this.authService.accessToken });

        if (includeJsonContentType)
            headers.append("Content-Type", "application/json");

        headers.append("Accept", 'application/json');
        headers.append("App-Version", ConfigurationService.appVersion);

        return new RequestOptions({ headers: headers });
    }
}



// WEBPACK FOOTER //
// ./node_modules/angular2-template-loader!./ClientApp/app/services/roles.service.ts